import { Component, Injectable, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
declare var Paho: any;

@Component({
  selector: 'app-mqttdashboard',
  templateUrl: './mqttdashboard.component.html',
  styleUrls: ['./mqttdashboard.component.scss']
})
@Injectable({
  providedIn: 'root'
})
export class MqttdashboardComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  private client: any;
  public tableheading;
  public dataSource;
  ELEMENT_DATA = [];
  constructor() {
    const CLIENT_ID = 'emqx_nodejs_' + Math.random().toString(16).substring(2, 8);

this.client = new Paho.MQTT.Client('broker.emqx.io', 8083, CLIENT_ID);

this.client.onConnectionLost = (responseObject: any) => {
  if (responseObject.errorCode !== 0) {
    console.log("Connection lost: " + responseObject.errorMessage);
  }
};

this.client.onMessageArrived = (message: any) => {
  console.log("Message Arrived: " + message.payloadString);
  // Update message handling as needed
  const currentDate = new Date(); // Current date and time
  const year = currentDate.getFullYear();
const month = currentDate.getMonth() + 1; // Adding 1 to adjust zero-based month
const day = currentDate.getDate();
const hours = currentDate.getHours();
const minutes = currentDate.getMinutes();
const seconds = currentDate.getSeconds();

// Convert each component to a string and pad single-digit values with leading zeros if needed
const dateString = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
const timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
const dateTimeString = `${dateString} ${timeString}`;

let data = JSON.parse(message.payloadString);
const updateData = { Timestamp: dateTimeString, ...data };

// Combine date and time strings into a single string

  this.tableheading = Object.keys(updateData);
  let jsonValuesData = updateData;
  Object.keys(jsonValuesData).forEach(function(key) {
    if(jsonValuesData[key] == -375){
      jsonValuesData[key] = 0;
    }
    if(key == "AI-1"){
      jsonValuesData[key] = Number(jsonValuesData[key])/10;
    }
  });
  this.ELEMENT_DATA.push(jsonValuesData);
  if(this.ELEMENT_DATA.length > 1 && !this.tableheading.includes("MODBUS Error")){
    this.updateData();
  }
};
this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
var options = {
  userName: 'deep',  // Add your MQTT broker username here
  password: 'admin',  // Add your MQTT broker password here
  onSuccess: () => {
    console.log("Connected to MQTT Broker");
    this.client.subscribe('ethModbus');
  },
  onFailure: (errorMessage: any) => {
    console.log("Failed to connect: " + errorMessage.errorMessage);
  }
};

this.client.connect(options);

  }

  ngOnInit() {
   
  }
  updateData(){
    this.dataSource.data=this.ELEMENT_DATA.slice().reverse();
  }
}
